<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Billing</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                :disabled="ffInvoiceModal.sentForRevisedApproval == '1' ? true : false"
                @click="openPop"
                size="sm"
                variant="warning"
                v-if="
                  mainExecutionDetails.length > 0 &&
                  (mainExecutionDetails[0].finalBillingCompleted == '1' || mainExecutionDetails[0].finalBillingCompleted == '4')
                "
                >Revised Billing Request</b-button
              ><br />
              <span class="error" v-if="ffInvoiceModal.revisedActionTakenFromMail == '2'"
                >Request Rejected</span
              >
              <span class="error" v-if="ffInvoiceModal.sentForRevisedApproval == '1'"
                >Sent For Approval</span
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
        v-if="$route.params.billingId"
          :allModuleIdBanner="$route.params.billingId ? $route.params.billingId : ''"
          :jobSeriesBanner="ffInvoiceModal.jobNo ? ffInvoiceModal.jobNo : ''"
          :bannerClientName="ffInvoiceModal.clientName ? ffInvoiceModal.clientName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <b-col md="12" class="pull-right">
                <ClientCard />
                 <ShipmentTrackCard />
                <BRFCard
                    v-if="brf_id"
                    :BRFDetails="null"
                    :prbr_id="Number(brf_id)"
                  />
                <!-- &&
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' -->
                <RejectInvTallyBill
                  v-if="newJobType.length > 0"
                  :RTBI_title="`Remove Or Reject Wrong Invoices Module JOB NO : ${mainExecutionDetails[0].mainSalesSeries}`"
                  :RTBI_JOBID="mainExecutionDetails[0].allModuleId"
                  :RTBI_JOBNO="mainExecutionDetails[0].mainSalesSeries"
                  :RTBI_JOBDATE="mainExecutionDetails[0].loginTime"
                  :RTBI_JOBTYPE="mainExecutionDetails[0].jobType"
                  :RTBI_Selected_JOBTYPE="newJobType"
                  :RTBI_IS_Consolidation="mainExecutionDetails[0].isConsolidation"
                  :RTBI_IS_Misc="mainExecutionDetails[0].isMiscJob"
                  :RTBI_Client="mainExecutionDetails[0].clientName"
                  :RTBI_clientId="mainExecutionDetails[0].clientId"
                  :RTBI_Sline="mainExecutionDetails[0].shippingId"
                  :RTBI_ffInvoiceModal="ffInvoiceModal"
                  :RTBI_showSegmentArray="showSegmentArray"
                  :RTBI_InvBtnRejection_btnFlag="InvBtnRejection_btnFlag"
                  :RTBI_InvTallyId="$route.query.InvTallyId"
                />
              </b-col>
            </b-row>
            <div v-if="billingTableData.length > 0" class="box-header">
              <b-button
                v-if="
                  mainExecutionDetails.length > 0 &&
                  mainExecutionDetails[0].finalBillingCompleted == '0'
                "
                size="sm"
                variant="outline-dark"
                @click="showMoreItem"
                class="pull-right"
                >{{
                  showMoreNewItem == false
                    ? "Show Existing Billing Details"
                    : "New Billing "
                }}</b-button
              >
              <b-button
                v-if="
                  mainExecutionDetails.length > 0 &&
                  (mainExecutionDetails[0].finalBillingCompleted != '1' || mainExecutionDetails[0].finalBillingCompleted != '4') &&
                  showMoreNewItem == true
                "
                size="sm"
                @click="closeBill(mainExecutionDetails[0].allModuleId)"
                variant="outline-info"
                >Close Billing</b-button
              >
              <span
                style="color: green"
                v-html="mainExecutionDetails[0].assignmentCloseReason"
                v-if="mainExecutionDetails[0].assignmentCloseReason"
                >{{ mainExecutionDetails[0].assignmentCloseReason }}</span
              >
              <!-- <b-button
                v-if="ffInvoiceModal.billingId!=''"
                size="sm"
                variant="success"
                @click="reload"
              >New Billing</b-button>-->
            </div>
            <div class="box" v-if="billingTableData.length > 0">
              <!-- /.box-header v-if="showMoreNewItem==false"-->
              <div class="box-body" v-if="showMoreNewItem == true">
                <!-- <label class="box-title">
                  <u>Existing Billing Details</u>
                </label>-->
                <table id="ffContainer" class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>#</th>
                      <th>Tally Invoice No.</th>
                      <th>Client Name</th>
                      <th>Job Type</th>
                      <th>Tally Status</th>
                      <th>Added In Tally</th>
                      <th>Date & Details</th>
                      <th>PDF</th>
                    </tr>
                    <tr
                      :style="
                        item1.TallyResponse == ''
                          ? 'color:red'
                          : item1.LINEERROR == '' && item1.CREATED != '0'
                          ? 'color:green '
                          : 'color:red'
                      "
                      v-for="(item1, index) in billingTableData"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td
                        :style="
                          item1.TallyResponse == ''
                            ? 'color:red'
                            : item1.LINEERROR == '' && item1.CREATED != '0'
                            ? 'color:green '
                            : 'color:red'
                        "
                        class="showMoreData"
                        @click="getBillData(item1)"
                      >
                        {{ item1.BillingSeries }}
                      </td>
                      <td>
                        {{ item1.clientName }}
                        <br />
                        <b-badge v-if="item1.invoiceForClient == '2'"
                          >Overseas Agent</b-badge
                        >
                      </td>
                      <td>{{ item1.jobType }}</td>
                      <td>
                        {{
                          item1.TallyResponse == ""
                            ? "Failed To connect to Tally"
                            : item1.LINEERROR == "" && item1.CREATED != "0"
                            ? "DATA ADDED SUCCESSFULLY IN TALLY "
                            : item1.LINEERROR
                        }}
                      </td>
                      <td>
                        <md-icon
                          :style="
                            item1.TallyResponse == ''
                              ? 'color:red'
                              : item1.LINEERROR == '' && item1.CREATED != '0'
                              ? 'color:green '
                              : 'color:red'
                          "
                          class="md-size md-accent"
                          >{{
                            item1.TallyResponse == ""
                              ? "clear"
                              : item1.LINEERROR == "" && item1.CREATED != "0"
                              ? "done_outline"
                              : "clear"
                          }}</md-icon
                        >
                      </td>

                      <td>
                        On {{ item1.loginTime }}
                        <br />
                        By {{ item1.employeeName }}
                        <br />
                        At {{ item1.billingLocationName }}
                      </td>

                      <td>
                        <a
                          v-if="item1.dataPdf"
                          :href="`${docURL}/TALLY_PDF/` + item1.dataPdf"
                          target="_blank"
                          download
                          >View PDF</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- /.box-body -->
            </div>
            <div v-if="showMoreNewItem == false || billingTableData.length == 0">
              <!-- <div  v-if="mainExecutionDetails[0].jobType">
<span><b>Execution Invoice</b><br></span>
              <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('FF')" 
                >FF  :- {{mainExecutionDetails[0].ffInvoiceClosed=='1'?'Received':'Not-Received'}}<br></span>
   <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('CC')" 
                >CC  :- {{mainExecutionDetails[0].ccInvoiceClosed=='1'?'Received':'Not-Received'}}<br></span>
   <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('TPT')" 
                >TPT  :- {{mainExecutionDetails[0].tptInvoiceClosed=='1'?'Received':'Not-Received'}}</span>
</div> -->
              <!-- /.box-body v-if="showMoreNewItem==true" -->
              <md-layout md-gutter class="gutr" v-if="ffInvoiceModal.billingId == ''">
                <md-layout md-flex="90" md-flex-small="100">
                  <md-layout md-flex-small="100">
                    <md-layout
                      v-for="(segmentNameArray, index) in showSegmentArray"
                      :key="index"
                      :md-flex="segmentNameArray.flex"
                      md-flex-small="100"
                    >
                      <!-- :disabled="ffExoprtDetail.allModuleId!=''?true:false" -->
                      <md-checkbox
                        v-model="ffInvoiceModal.jobType[index]"
                        class="md-primary"
                        :md-value="segmentNameArray.value"
                        :name="'jobType' + (index + 1)"
                        :id="'jobType' + (index + 1)"
                        @change="
                          jobTypeSelect(segmentNameArray.value, index);
                          getOceanFreight();
                        "
                      >
                        <b>{{ segmentNameArray.show }}</b>
                      </md-checkbox>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>

              <!-- Added By Priyanshu Singh Previous Tally Data Get Start -->
              <div
                class="box"
                v-if="PreviousbillingTableData.length > 0 && newJobType.length > 0"
              >
                <div class="box-body row">
                  <div
                    class="col-md-2"
                    v-for="(pre_item, pre_index) in PreviousbillingTableData"
                    :key="pre_index"
                  >
                    <b-button
                      style="font-size: 0.675rem"
                      class="mt-2"
                      v-if="pre_item.BillingSeries"
                      size="sm"
                      @click="getPreviousTallyData(pre_item)"
                      variant="info"
                      ><b>{{ pre_item.BillingSeries }}</b></b-button
                    >
                  </div>
                </div>
              </div>
              <!-- Added By Priyanshu Singh Previous Tally Data Get End -->

              <div>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <label>Job No.</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        disabled
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.jobNo"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>Employee Billing Branch</label>
                      <model-list-select
                        :isDisabled="
                          $sessionsStorage.get('designation') != 'Admin' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        "
                        @input="getBillingBranch"
                        :list="billingLocationData"
                        v-model="ffInvoiceModal.billingLocationId"
                        option-value="billingLocationId"
                        option-text="billingLocation"
                        placeholder="Select Billing Location"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label for="containerTypeId">Billing Status</label>
                    <model-list-select
                      :list="invoiceStatusList"
                      v-model="ffInvoiceModal.billingStatus"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Status"
                    ></model-list-select>
                  </md-layout> -->
                  <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Date</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientName"
                  disabled
                  name="clientName"
                  v-model="ffInvoiceModal.invDate"
                ></b-form-input>
              </md-layout>
                  </md-layout>-->
                </md-layout>
                <md-layout md-gutter class="gutr"> </md-layout>

                <md-layout md-gutter class="gutr">
                  <div class="mr-4">
                    <label style="width: 44px"> Other Clients</label>
                    <b-form-checkbox
                      style="padding-top: 0px"
                      v-model="otherClientChecked"
                      name="check-button"
                      switch
                    >
                    </b-form-checkbox>
                  </div>

                  <md-layout
                    md-flex="20"
                    v-if="
                      mainExecutionDetails.length > 0 &&
                      mainExecutionDetails[0].clientType == '3'
                    "
                  >
                    <label for="containerTypeId">Invoice For</label>
                    <model-list-select
                      @input="changeClient"
                      :list="clientTypeList"
                      v-model="ffInvoiceModal.invoiceForClient"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="
                      mainExecutionDetails.length > 0 &&
                      mainExecutionDetails[0].clientType == '3'
                    "
                  ></md-layout>
                  <md-layout md-flex="45">
                    <label for="containerTypeId">Client Name</label>
                    <model-list-select
                      :isDisabled="otherClientChecked == false ? true : false"
                      @input="changeOtherClient"
                      :list="clientData"
                      v-model="ffInvoiceModal.clientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <!-- <md-layout md-flex="50" >
                    <md-layout md-flex="100">
                      <label>Client Name</label>
                      <b-form-input :formatter="capitalizeAll"
                        disabled
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.clientName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>  -->
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Client Contact</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.contact"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Client GSTN</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.clientgst"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>State</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.stateName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>Client Address</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.adress"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <div>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Pickup Location</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.pickup"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Handover Location</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.Handover"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Factory Location</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.factoryLoc"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Place Of Receipt</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.POR"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Load Port</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.LP"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Port Of Discharge</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.POD"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Final Place of Delivery</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.FPOD"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Shipping Line Name</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.shippingLine"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Vessel / Voyage</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.vessel"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <h5 class="mt-4">
                    <b-badge variant="info"
                      >Container Details : {{ allContainersDataArray.length }} Container
                    </b-badge>
                  </h5>
                  <md-layout
                    md-gutter
                    class="gutr"
                    v-if="splitedOrMergedContainers.length > 0"
                  >
                    <md-layout md-flex="40">
                      <label>Container Moved to other assignment </label>
                      <model-list-select
                        @input="pushSplitedContainers"
                        :list="splitedOrMergedContainers"
                        v-model="splitOrMergeConNo"
                        option-value="uniqueContainerId"
                        option-text="containerNo"
                        placeholder=""
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <table class="table table-sm mt-4 shadow p-3 mb-5 bg-white rounded">
                    <tbody>
                      <tr>
                        <th bgcolor="whiteSmoke" style="width: 20px">
                          <!-- <b-form-checkbox
              v-model="checkAll"
             
              style="height: 2px !important"
              class="align-center"
              size="lg"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox> -->
                          <input
                            type="checkbox"
                            @click="SelectAll(allContainersDataArray)"
                            v-model="isCheckAll"
                          />
                          <label
                            >Select All Count({{
                              this.singleSelectContainer.length
                            }})</label
                          >
                        </th>
                        <th bgcolor="whiteSmoke">Container Type & No.</th>
                        <!-- <th>Wgt. & Measurement</th> -->

                        <th>Shipping Bills</th>
                        <th>Shipper Invoices</th>
                        <th>Invoice Added JobNo</th>
                      </tr>
                      <tr v-for="(item, index) in allContainersDataArray" :key="index">
                        <td
                          style="text-align: center; vertical-align: middle; width: 20px"
                          bgcolor="whiteSmoke"
                        >
                          <!-- :disabled="
                              (item.splitedToOrMergedToAssignId != '0' &&
                                (newJobType.includes('FF') ||
                                  newJobType.includes('CC'))) ||
                              (item.containerIsLinked != '1' &&
                                newJobType.includes('TPT')) ||
                              (item.fromSplitMergeAssignId != '0' &&
                                item.containerIsLinked != '1' &&
                                newJobType.includes('TPT'))
                                ? true
                                : false
                            " -->
                          <b-form-checkbox
                            :disabled="
                              item.onlyTPT == '1' &&
                              (newJobType.includes('FF') ||
                                newJobType.includes('CC') ||
                                newJobType.length <= 0)
                                ? true
                                : false
                            "
                            size="lg"
                            v-model="singleSelectContainer"
                            :value="item.uniqueContainerId"
                            @change="updateSelectAll($event, item)"
                          ></b-form-checkbox>
                        </td>
                        <td
                          style="text-align: left; vertical-align: middle; width: 200px"
                          :bgcolor="item.onlyTPT == '1' ? 'red' : 'whiteSmoke'"
                        >
                          <span>{{ item.containerType }} </span>
                          <b v-if="item.containerNo"><br />{{ item.containerNo }}</b>
                          <br />
                          <b-button
                            v-if="item.onlyTPT == '1'"
                            @click="removeContainerType(index)"
                            size="sm"
                            class="pull-right"
                            variant="warning"
                          >
                            <i class="fa fa-minus-circle"></i>
                          </b-button>
                          <!-- <span
                            style="color: yellow"
                            v-if="item.isSplitedOrMerged == '1'"
                            ><br />Container Moved to
                            {{ item.splitedToOrMergedToAssigNo }} for FF</span
                          > -->
                          <span style="color: blue" v-if="item.invoiceNoCreated"
                            ><br /><b
                              >Invoice Created: {{ item.invoiceNoCreated }}</b
                            ></span
                          >
                          <!-- <span
                            style="color: yellow"
                            v-if="item.fromSplitMergeAssignId != '0'"
                            ><br />Container Added from
                            {{ item.fromSplitMergeAssignNo }} for FF</span
                          > -->
                        </td>
                        <!-- <td>
            Net Wgt. : {{ item.netWeight }}<br />Gross Wgt. :
            {{ item.grossWeight }}<br />Tare Wgt. : {{ item.tareWeight
            }}<br />Unit :{{ item.weightUnit }}<br />Measurement :
            {{ item.measurement }}
          </td> -->

                        <td>
                          SB No. : {{ item.shippingBillNo }}<br />
                          SB Date :
                          {{ item.shippingBillDate ? item.shippingBillDate : "" }}
                        </td>
                        <td>
                          Shipper Inv No. : {{ item.shipperInvoiceNo }}<br />
                          Date :
                          {{
                            item.shipperInvoiceDate
                              ? item.shipperInvoiceDate.split(" ")[0]
                              : ""
                          }}
                        </td>
                        <td>
                          {{ item.assignNoInwhichInvCreated }}
                          <!-- <b-button
                            @click="linkContainer(item, '1')"
                            v-b-tooltip.hover
                            title="Link container to this assignment"
                            v-if="item.containerIsLinked == '0'"
                            style="font-size: 0.675rem"
                            size="sm"
                            variant="outline-info"
                            >Link-Container</b-button
                          > -->
                        </td>
                        <!-- <td>
            Package : {{ item.packageName }}<br />
            No.of Package : {{ item.noOfpkgUnit }}

            <span v-if="JOB == 'CC'"
              ><br />Booking No. : {{ item.containerBookingNo }}
            </span>
          </td> -->
                      </tr>
                    </tbody>
                  </table>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Container No.</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.containerDetailsNew"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Container Type</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="multipleContainerType"
                          name="multipleContainerType"
                          v-model="ffInvoiceModal.multipleContainerType"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Shipping Bill No/ Date</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.BOE"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Shipper Invoice No.</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientRegistrationNo"
                          name="clientRegistrationNo"
                          v-model="ffInvoiceModal.shipperInvNo"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Shipper Invoice Date</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientRegistrationNo"
                          name="clientRegistrationNo"
                          v-model="ffInvoiceModal.shipperInvDate"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>BL No</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.blNo"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Weight (KGS)</label>
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.weight"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <div class="gutr">
                    <div class="box-body gutr" v-if="TPTGRNDATA.length > 0">
                      <h5>
                        <b-badge variant="info">TPT Annexure Details</b-badge>
                      </h5>
                      <table
                        id="quotationDetail"
                        class="table table-bordered table-sm gutr"
                      >
                        <tbody>
                          <tr>
                            <!-- <th>Action</th> -->
                            <th>GRN Number</th>
                            <th>Container Number & Type</th>
                            <th>Fuel Slip No.</th>
                            <th>Vehicle No</th>
                            <th>S-Line Seal No.</th>
                            <th>Custom Seal No.</th>
                            <th>Date</th>
                          </tr>
                          <tr v-for="(item, index) in TPTGRNDATA" :key="index">
                            <!-- <td>
                              <b-button
                                disabled
                                variant="outline-warning"
                                size="sm"
                                v-if="item.billingToTallDone == 1"
                                >Billing Done</b-button
                              >

                              <b-button
                                disabled
                                variant="outline-warning"
                                size="sm"
                                v-if="item.invoiceStatus != 0"
                                >Invoice Pending From TPT</b-button
                              >

                              <b-button
                                variant="light"
                                size="sm"
                                @click="removeGRN(index, item)"
                                >Remove</b-button
                              >
                            </td> -->

                            <td>
                              <a @click="getGRNpdf(item.pdfGRN)" class="error"
                                ><span class="error"
                                  ><u> {{ item.GRNSeries }}</u>
                                </span></a
                              >
                            </td>

                            <td>
                              {{ item.containerNo }}
                              <br />
                              {{ item.multipleContainerType }}
                            </td>
                            <td>{{ item.FuelSlipNo }}</td>
                            <td>{{ item.vehicleNo }}</td>
                            <td>{{ item.slineSealNo }}</td>
                            <td>{{ item.customSealNo }}</td>
                            <td>
                              <span>Loading Date :{{ item.Date | moment }}</span>
                              <br />
                              <span
                                >Reporting Date :{{ item.factoryInDate | moment }}</span
                              >
                              <br />
                              <span
                                >Released Date :{{ item.factoryOutDate | moment }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- <md-layout md-gutter class="gutr">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="90">
                    <md-layout md-flex="100">
                      <label>Port Charges Details</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="PortAdditionalCharges"
                        name="PortAdditionalCharges"
                        v-model="ffInvoiceModal.PortAdditionalCharges"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  </md-layout>-->

                  <!-- Other Expenses -->
                  <div class="gutr hide">
                    <div class="box-body gutr">
                      <h5>
                        <b-badge variant="info">Expense Details</b-badge>
                      </h5>
                      <table id="otherExpense" class="table table-bordered table-sm gutr">
                        <tbody>
                          <tr>
                            <!-- <th>Action</th> -->
                            <!-- Added By Priyanshu Singh Start -->
                            <th>Vendor Name</th>
                            <th>Invoice Type</th>
                            <th>Invoice No.</th>
                            <th>Expense Amount</th>
                            <th>Expense Currency</th>
                            <th>Remark</th>
                            <th>Added on</th>
                            <!-- Added By Priyanshu Singh End -->

                            <!-- <th>Expense</th>
                            <th>Amount</th>
                            <th>Remark</th>
                            <th>Added on</th> -->
                          </tr>
                          <!-- Added By Priyanshu Singh Start -->
                          <tr v-for="(item, index) in otherExpenseData" :key="index">
                            <td>{{ item.vendorName }}</td>
                            <td>{{ item.exp_type }}</td>
                            <td>{{ item.invoice_no }}</td>
                            <td>{{ item.exp_amount }}</td>
                            <td>{{ item.exp_Currency }}</td>
                            <td>{{ item.exp_remarks }}</td>
                            <td>{{ item.loginTime }}</td>
                          </tr>
                          <!-- Added By Priyanshu Singh End -->
                          <!-- <tr
                            v-for="(item, index) in otherExpenseData"
                            :key="index"
                          >
                            <td>
                              {{ item.ledger }}
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.remark }}</td>
                            <td>{{ item.loginTime }}</td>
                          </tr> -->
                          <tr v-if="otherExpenseData.length <= 0">
                            <td colspan="7" style="text-align: center; color: red">
                              <b>NO EXPENSE ADDED</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="gutr">
                    <Profit-Loss
                      v-if="ffInvoiceModal.allModuleId"
                      :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                      :PMS_jb_series="ffInvoiceModal.jobNo"
                      :PMS_fk_client_id="ffInvoiceModal.clientName"
                      :PLAccordianStatus="false"
                      :PLAccordianButton="true"
                    />
                    <Assignment-Timeline
                      :TMAccordianStatus="false"
                      :TMAccordianButton="true"
                      :allModuleId="Number(ffInvoiceModal.allModuleId)"
                    />
                    <Payment-Summary
                      v-if="ffInvoiceModal.allModuleId"
                      :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                      :PMS_jb_series="ffInvoiceModal.jobNo"
                      :PMS_fk_client_id="ffInvoiceModal.clientName"
                    />
                    <ExpenseTableComponent
                      v-if="ffInvoiceModal.allModuleId && is_noe_validation"
                      :show-debug="false"
                      :initial-expenses="initialExpenses"
                      :enable-validation="true"
                      ref="expenseTableComponent"
                      @expenses-saved="handleExpensesSaved"
                      @expense-validation="handleExpenseValidation"
                      :allModuleId="ffInvoiceModal.allModuleId"
                      :jobNo="ffInvoiceModal.jobNo"
                      :moduleType="'FF Con'"
                      :transportType="'Export'"
                      :branchId="$sessionsStorage.get('branch_baseLocation')"
                      :invoiceStatus="1"
                    />
                    <!-- Old & New Additional Task Records (only Additional Task) -->
                    <OldExpenseAdditionalTask
                      v-if="ffInvoiceModal.allModuleId"
                      :allModuleId="ffInvoiceModal.allModuleId"
                      :type="'additional-task'"
                    />
                    <!-- <div class="box-body gutr">
                      <h5>
                        <b-badge
                          :variant="
                            otherAdditionalTask_Data.length > 0 ? 'warning' : 'info'
                          "
                          >Additional Task Request</b-badge
                        >
                      </h5>
                      <table
                        id="otherAdditionalTask"
                        class="table table-bordered table-sm gutr"
                        :style="
                          otherAdditionalTask_Data.length > 0
                            ? 'background-color:yellow;font-weight:bold'
                            : ''
                        "
                      >
                        <tbody>
                          <tr>
                            <th>Expense</th>
                            <th>Amount</th>
                            <th>Remark</th>
                            <th>Added on</th>
                          </tr>

                          <tr
                            v-for="(item, index) in otherAdditionalTask_Data"
                            :key="index"
                          >
                            <td>
                              {{ item.ledger }}
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.remark }}</td>
                            <td>{{ item.loginTime }}</td>
                          </tr>
                          <tr v-if="otherAdditionalTask_Data.length <= 0">
                            <td colspan="4" style="text-align: center; color: red">
                              <b>NO Additional Task Request ADDED</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="box-body gutr">
                      <h5>
                        <b-badge variant="info">Sline Payment Details</b-badge>
                      </h5>
                      <table
                        id="otherAdditionalTask"
                        class="table table-bordered table-sm gutr"
                      >
                        <tbody>
                          <tr>
                            <th>Invoice No</th>
                            <th>Invoice Category</th>
                            <th>Invoice Type</th>
                            <th>Invoice Amount</th>
                            <th>Payment Mode</th>
                            <th>Payment Refrence No.</th>
                            <th>Payment Amount</th>
                            <th>Payment Date</th>
                            <th>Payment Status</th>
                            <th>Bill to Shipper</th>
                            <th>Bill to Shipper Remark</th>
                          </tr>

                          <tr v-for="(item, index) in SlinePayment_Data" :key="index">
                            <td>
                              <a
                                v-if="item.SlineUpload"
                                style="color: blue"
                                href="javascript:void(0)"
                                @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${item.ffExportFclConsoSeries.replaceAll('/', '_')}/${item.SlineUpload.replaceAll('/', '_')}`)"
                                ><b
                                  ><u>{{ item.SlineInvNo }}</u></b
                                ></a
                              >
                            </td>
                            <td>{{ item.SlineInvCategory }}</td>
                            <td>{{ item.newSlineInvType }}</td>
                            <td>{{ item.SlineInvAmount }}</td>
                            <td>
                              <span v-if="item.SlineInvPayMode == 1">RTGS</span>
                              <span v-else-if="item.SlineInvPayMode == 2">Cheque</span>
                              <span v-else></span>
                            </td>
                            <td>{{ item.SlineInvPayRef }}</td>
                            <td>{{ item.SlineInvPaidAmount }}</td>
                            <td>{{ item.SlineInvPayDate }}</td>
                            <td>
                              <span v-if="item.SlineInvPayStatus == 1">Partial</span>
                              <span v-else-if="item.SlineInvPayStatus == 2"
                                >Completed</span
                              >
                              <span v-else>Pending</span>
                            </td>
                            <td>{{ item.scCategory }}</td>
                            <td>{{ item.scremark }}</td>
                          </tr>
                          <tr v-if="SlinePayment_Data.length <= 0">
                            <td colspan="7" style="text-align: center; color: red">
                              <b>NO Sline Payment Details</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="box-body gutr">
                      <h5>
                        <b-badge
                          :variant="ExpenseDoc_Data.length > 0 ? 'warning' : 'info'"
                          >Expense Document Details</b-badge
                        >
                      </h5>
                      <table
                        id="otherAdditionalTask"
                        class="table table-bordered table-sm gutr"
                        :style="
                          ExpenseDoc_Data.length > 0
                            ? 'background-color:yellow;font-weight:bold'
                            : ''
                        "
                      >
                        <tbody>
                          <tr>
                            <th>Expense Date</th>
                            <th>View</th>
                          </tr>

                          <tr v-for="(item, index) in ExpenseDoc_Data" :key="index">
                            <td>{{ item.expenseDate }}</td>
                            <td>
                              <a
                                v-if="item.documentLink"
                                href="javascript:void(0)"
                                @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${item.mainSalesSeries.replaceAll('/', '_')}/${item.documentLink.replaceAll('/', '_')}`)"
                                >{{ item.otherDocName }}</a>
                            </td>
                          </tr>
                          <tr v-if="ExpenseDoc_Data.length <= 0">
                            <td colspan="2" style="text-align: center; color: red">
                              <b>NO Expense Document ADDED</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->
                  </div>

                  <b-row
                    v-if="
                      oceanFreight.indexOf('OCEAN FREIGHT CHARGES-EXPORT') >= 0 ||
                      oceanFreight.indexOf('OCEAN FREIGHT SEZ') >= 0 ||
                      oceanFreight.indexOf('OCEAN FREIGHT CHARGES-IMPORT') >= 0
                    "
                  >
                    <b-col md="2">
                      <label>
                        Ocean Freight Buying Rates <span class="error">*</span></label
                      >
                      <b-form-input
                        disabled
                        :formatter="capitalizeAll"
                        name="oe_oceanf_rate"
                        id="oe_oceanf_rate"
                        v-model="common_details.oe_oceanf_rate"
                        type="number"
                      ></b-form-input>
                      <span
                        class="error"
                        v-if="common_details.oceanFreightRate_err ? true : false"
                        >{{ common_details.oceanFreightRate_err }}</span
                      >
                    </b-col>

                    <b-col md="2">
                      <label>
                        Ocean Freight Selling Rates <span class="error">*</span></label
                      >
                      <b-form-input
                        :formatter="capitalizeAll"
                        name="oe_oceanf_sell_rate"
                        id="oe_oceanf_sell_rate"
                        v-model="common_details.oe_oceanf_sell_rate"
                        type="number"
                        @input="checkBSRate()"
                      ></b-form-input>
                      <span
                        class="error"
                        v-if="common_details.oceanFreightRate_err ? true : false"
                        >{{ common_details.oceanFreightRate_err }}</span
                      >
                    </b-col>

                    <b-col md="2">
                      <label>Currency<span class="error">*</span></label>
                      <model-list-select
                        isDisabled
                        :list="$store.getters['common/getAllCurrencyList']"
                        v-model="common_details.oe_fk_currency_id"
                        option-value="currency_id"
                        option-text="currencyCode"
                        placeholder="Select Currency"
                      ></model-list-select>
                      <span
                        class="error"
                        v-if="common_details.currency_err ? true : false"
                        >{{ common_details.currency_err }}</span
                      >
                    </b-col>

                    <b-col md="3">
                      <label>Remark :</label>
                      <b-form-textarea
                        disabled
                        :formatter="capitalizeAll"
                        id="oe_oceanf_remark"
                        name="oe_oceanf_remark"
                        v-model="common_details.oe_oceanf_remark"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>

                  <!-- <div class="gutr">
                    <div class="box-body gutr">
                      <h5>
                        <b-badge variant="info">Expense Details</b-badge>
                      </h5>
                      <table
                        id="otherExpense"
                        class="table table-bordered table-sm gutr"
                      >
                        <tbody>
                          <tr>
                            <th>Expense</th>
                            <th>Amount</th>
                            <th>Remark</th>
                            <th>Added on</th>
                          </tr>
                          <tr
                            v-for="(item, index) in otherExpenseData"
                            :key="index"
                          >
                            <td>
                              {{ item.ledger }}
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.remark }}</td>
                            <td>{{ item.loginTime }}</td>
                          </tr>
                          <tr v-if="otherExpenseData.length <= 0">
                            <td
                              colspan="4"
                              style="text-align: center; color: red"
                            >
                              <b>NO EXPENSE ADDED</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </b-card-text>
        </b-card>
        <div
          class="mt-2"
          v-if="
            showMoreNewItem == false ||
            ffInvoiceModal.billingId != '' ||
            billingTableData.length == 0
          "
        >
          <b-form-checkbox
            v-if="
              ffInvoiceModal.billingId != '' &&
              mainExecutionDetails.length > 0 &&
              mainExecutionDetails[0].finalBillingCompleted == '0'
            "
            size="lg"
            @change="copyCharges"
            value="notSelected"
            v-model="selectedTallyInv"
            >Select to Update Charges Details</b-form-checkbox
          >

          <div>
            <h5>
              <b-badge variant="info">CHARGES </b-badge>
              <b-button
                class="ml-1"
                v-if="ffInvoiceModal.billingId == ''"
                size="sm"
                variant="outline-info"
                @click="addQuotationFields"
              >
                <!-- @click="addQuotationFields" -->
                <md-icon md-va>add</md-icon>
              </b-button>
            </h5>
            <table
              id="quotationDetail"
              class="table table-responsive-lg mt-3 table-light table-bordered shadow p-3 mb-5 bg-white rounded"
            >
              <tbody>
                <tr>
                  <th style="width: 45px">
                    <b-form-checkbox
                      v-model="slectedAllStatus"
                      class="ml-2"
                      value="1"
                      unchecked-value="0"
                      @input="SelectedAll"
                    >
                    </b-form-checkbox>
                  </th>

                  <th style="width: 170px"><span>Particulars * </span></th>

                  <th v-if="shipmentType == '1' || shipmentType == 'Sea_Shipment'">
                    <span>Container Type</span>
                  </th>
                  <th style="width: 82px"><span>Quantity *</span></th>
                  <th><span>Currency *</span></th>
                  <th style="width: 130px"><span>Quotation Rate *</span></th>
                  <th style="width: 130px"><span>Selling Rate *</span></th>
                  <th style="width: 100px"><span>Exch Rate *</span></th>

                  <th style="width: 130px"><span>Final Amount *</span></th>

                  <th><span>Unit *</span></th>
                  <th><span>Remarks</span></th>
                </tr>
                <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                  <td :bgColor="item.color && item.color == '1' ? 'green' : ''">
                    <b-form-checkbox
                      v-model="item.slectedStatus"
                      class="mt-3 ml-2"
                      value="1"
                      unchecked-value="0"
                      @change="SelectedAllItem(item, index)"
                    >
                    </b-form-checkbox>
                    <!-- <b-button
                  
                      size="sm"
                      variant="danger"
                        v-if="ffTallyInvoiceData.length>1 &&  ffInvoiceModal.billingId==''"
                    
                        @click="removeCol(index)"
                      
                      >
                       Remove
                      </b-button> -->
                  </td>
                  <!-- <td>{{index+1}}</td> 
                    :isDisabled="item.mainffId!=''?true:false"-->
                  <td>
                    <model-list-select 
                        :list="$store.getters['common/getAllLedgerList']" 
                        v-model="item.ffType"
                        @input="
                        getDuplicateLedger(item, index);
                        getOceanFreight();
                      "
                        option-value="ledger" 
                        option-text="ledger" 
                        placeholder="Select Particular">
                        </model-list-select>
                    <!-- <model-list-select
                      class="parti"
                      :list="ledgerData"
                      @input="
                        getDuplicateLedger(item, index);
                        getOceanFreight();
                      "
                      v-model="item.ffType"
                      option-value="ledger"
                      option-text="ledger"
                    ></model-list-select> -->
                  </td>
                  <td v-if="shipmentType == '1' || shipmentType == 'Sea_Shipment'">
                    <model-list-select
                      v-if="shipmentType == '1' || shipmentType == 'Sea_Shipment'"
                      :list="containerMasterData"
                      v-model="item.containerType"
                      option-value="containerType"
                      option-text="containerType"
                    ></model-list-select>
                    <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.mainffId!=''?true:false" v-model="item.ffType"></b-form-input> -->
                  </td>
                  <!-- :isDisabled="item.mainffId!=''?true:false" -->

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.quantity"
                    ></b-form-input>
                  </td>
                  <td>
                    <model-list-select
                      :list="currencyList"
                      v-model="item.currency"
                      option-value="currencyV"
                      option-text="currencyT"
                    ></model-list-select>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="item.ffSellingRate ? true : false"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.ffSellingRate"
                    ></b-form-input>
                  </td>

                  <!-- :disabled="item.mainffId!=''?true:false" -->
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.sellingRateFinal"
                    ></b-form-input>
                  </td>

                  <!-- :disabled="item.ffSellingRate==''?true:false" -->

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.exchRate"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      type="number"
                      v-model="item.invAmount"
                      v-on:keyup="MainParticular"
                    ></b-form-input>
                  </td>

                  <td>
                    <model-list-select
                      :list="unitList"
                      v-model="item.unit"
                      option-value="unitId"
                      option-text="unitName"
                    ></model-list-select>
                  </td>
                  <!-- :isDisabled="item.mainffId!=''?true:false" -->

                  <td>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      v-model="item.remark"
                    ></b-form-textarea>
                  </td>
                  <td>
                    <b-button
                    size="sm"
                    @click="removeParticular(index)"
                  >
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                  </td>
                </tr>
                <tr v-if="ffTallyInvoiceData.length > 0">
                  <td colspan="8"></td>
                  <td colspan="2">
                    <b>Total :</b>
                    <span>
                      <b>{{ totFinalPartAmount }}</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
              </md-layout>-->
          <md-layout md-gutter class="mrgtop-2per gutr mt-5">
            <md-layout md-flex="35"></md-layout>
            <md-layout md-flex="30">
              <b-button
                block
                v-if="ffInvoiceModal.billingId == ''"
                variant="primary"
                @click="validateBillingParticulars"
                id="addButtonLoader"
                >{{
                  ffInvoiceModal.billingId != "" ? "Update" : "Send Data To Tally"
                }}</b-button
              >
              <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
            </md-layout>
            <md-layout md-flex="20"></md-layout>
            <!-- <md-layout md-flex="15">
                  <b-button
                
                    v-if="validateTally==true"
                    variant="dark"
                   
                    @click="quoteChangeApproval('2')"
                  >Send For Approval</b-button>
                </md-layout> -->
          </md-layout>
        </div>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopMaxPer"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="submitInvoice"
      ref="addPopTally"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="handleBillingClose"
      ref="addValidateClose"
    ></md-dialog-confirm>
    
    <!-- @confirm="addDataTally" -->
    <!-- <b-modal ref="customDialog" hide-footer>
    <template #modal-title>
      <h5>Confirmation</h5>
    </template>
    <div>
      {{ alert.content }}
    </div>
    <template #modal-footer>
      <b-button @click="close">OK</b-button> -->
      <!-- <b-button @click="confirmBilling">OK</b-button> -->
      <!-- <b-button @click="close">Cancel</b-button> -->
    <!-- </template>
  </b-modal> -->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus,getJobNatureOfExpenseList } from "../../helper/collection";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import PaymentSummary from "../common/paymentSummary.vue";
import ProfitLoss from "../common/profitLoss.vue";
import AssignmentTimeline from "../common/assignmentTimeline.vue";
import CommonService from "../../services/CommonService.js";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import RejectInvTallyBill from "../common/rejectInvTallyBill.vue";
import BRFCard from "../common/brfCard.vue";
import ExpenseTableComponent from "../common/expenseTableComponent.vue"; 
import OldExpenseAdditionalTask from "../allModuleForm/components/OldExpenseAdditionalTask.vue";
export default {
  beforeMount() {
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/freightInvoiceForTally");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      brf_id:0,
      InvBtnRejection_btnFlag: false,
      customMSG: "",
      isCheckAll: false,
      totFinalPartAmount: "0",
      classId: "",
      billingLocationData: [],
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      invoiceStatusList: [
        {
          inv: "0",
          int: "In-Complete",
        },
        {
          inv: "1",
          int: "Completed",
        },
      ],
      splitOrMergeConNo: "",
      showMoreNewItem: true,
      selectedTallyInv: "",
      selectedAllModuleId: "",
      showBill: false,
      ccInvoiceTallyData: [],
      tallyTableData: [],
      validateTally: false,
      unitList: [],
      docURL: URL_BASE_DOC,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],

      isLoading: false,
      containerNoName: [],
      TPTInvoiceTallyData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      CCCheckDone: 0,
      ffCheckDone: 0,
      TPTCheckDone: 0,
      ledgerData: [],
      clientData: [],
      TPTGRNDATA: [],
      otherExpenseData: [],
      otherAdditionalTask_Data: [],
      SlinePayment_Data: [],
      ExpenseDoc_Data: [],
      TPTGRNID: [],
      TPTMERGECONTAINERCHARGEID: [],

      TOLLPRICE: "",
      shipmentType: "",
      billingTableData: [],
      PreviousbillingTableData: [],
      PreviousTallyItemTable: [],
      containerMasterData: [],
      mainExecutionDetails: [],
      jobTypeSelectVal: false,
      showSegmentArray: [],
      clientTypeList: [
        {
          inv: "1",
          int: "Client",
        },
        {
          inv: "2",
          int: "Oversea Agent",
        },
      ],
      cTypeList: [
        {
          inv: "1",
          int: "Client",
        },
      ],
      overTypeList: [
        {
          inv: "2",
          int: "Oversea Agent",
        },
      ],
      showOverSea: false,
      selectedValue: "",
      clist: false,
      slectedAllStatus: "0",
      otherClientChecked: false,
      ffInvoiceModal: {
        splitFromId: "",
        fromAgentColoderTable: "N",
        manualBilling: "0",
        tallyBillingSeries: 1,
        billingStatus: "0",
        invoiceForClient: "",
        acutalclientForOverSea: "",
        otherChargeFF: "",
        BILLDONE: [],
        FFtallyId: [],
        billingLocationId: "",
        billingLocationName: "",
        shipperInvNoforTally: "",
        shipperInvDateforTally: "",
        shipperInvNo: "",
        shipperInvDate: "",
        stateName: "",
        clientgst: "",
        TOLCHRG: "",
        TPTCHARGES: "",
        secondFF: "",
        multiTPT: "",
        grnNo: "",
        pickup: "",
        Handover: "",
        factoryLoc: "",

        jobType: [],
        jobTypeName: [],
        chnageApprovalStatus: "",
        billingId: "",
        invDate: "",
        jobNo: "",
        sentForRevisedApproval: "",
        revisedActionTakenFromMail: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        BOE: "",
        clientId: "",
        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetailsNew: "",
        containerDetailsCC: [],
        containerDetails: [],
        multipleContainerType: "",
        multiConNo: [],
        shippingLine: "",
      },
      newJobType: [],
      disableJobType: [],
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      ccContainers: [],
      ffContainers: [],
      revisedSavedBillingData: [],
      allContainersDataArray: [],
      splitedOrMergedContainers: [],
      singleSelectContainer: [],
      oceanFreight: [],
      common_details: {
        oe_oceanf_rate: "",
        oe_oceanf_sell_rate: "",
        oe_fk_currency_id: "",
        oe_oceanf_remark: "",
      },

       expenseValidation: {
        isValid: true,
        messages: [],
        fieldErrors: {}
      },
      initialExpenses: [],
      is_noe_validation: false,
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    PaymentSummary,
    ProfitLoss,
    AssignmentTimeline,
    ClientCard,
    ShipmentTrackCard,
    ShipmentTrackCard,
    RejectInvTallyBill,
    BRFCard,
    ExpenseTableComponent,
    OldExpenseAdditionalTask,
  },
  watch: {
    singleSelectContainer(newVal, oldVal) {
      console.log("dd");
      let dataArray = [];
      this.TPTGRNID = [];
      this.TPTMERGECONTAINERCHARGEID = [];
      let conArry = [];
      let conTypeAry = [];
      let SBNo_Arry = [];
      let SBNo_DateArry = [];
      let shiperInvArry = [];
      let shipperInvDateArry = [];

      for (let j = 0; j < this.singleSelectContainer.length; j++) {
        let arrySelect = this.allContainersDataArray.filter((p) => {
          return p.uniqueContainerId == this.singleSelectContainer[j];
        });
        dataArray.push(...arrySelect);

        // let arryGR = this.DUMMYTPTGRNDATA.filter((q) => {
        //   return q.containerNo.split(",").includes(arrySelect[0].containerNo);
        // });
        // if (arryGR.length > 0) {
        //   this.TPTGRNDATA.push(...arryGR);
        // }

        //  if (data.TPTGRNDATA.length > 0) {
        //                this.DUMMYTPTGRNDATA = data.TPTGRNDATA;
        //

        //             }
      }

      for (let t = 0; t < dataArray.length; t++) {
        if (dataArray[t].moduleIdInwhichInvCreated) {
          if (
            dataArray[t].moduleIdInwhichInvCreated.split(",")[0] !==
            this.ffInvoiceModal.allModuleId
          ) {
            this.alert.content = "Container Already  Billed in other assignment ";
            this.$refs["addPop"].open();
          }
        }
        this.TPTGRNID.push(dataArray[t].tptGrnId);
        if (dataArray[t].fromSplitMergeAssignId != 0) {
          console.log(dataArray[t].fromSplitMergeAssignId);
          this.TPTMERGECONTAINERCHARGEID.push(dataArray[t].tptGrnAssignmentId);
        }
        conArry.push(dataArray[t].containerNo);
        conTypeAry.push(dataArray[t].containerType);
        console.log("Priyanshu SIngh conArry=>", conArry);
        console.log("Priyanshu SIngh conTypeAry=>", conTypeAry);
        if (dataArray[t].shippingBillNo) {
          SBNo_Arry.push(dataArray[t].shippingBillNo);
        }
        if (dataArray[t].shippingBillDate) {
          SBNo_DateArry.push(dataArray[t].shippingBillDate);
        }
        if (dataArray[t].shipperInvoiceNo) {
          shiperInvArry.push(dataArray[t].shipperInvoiceNo);
        }
        if (dataArray[t].shipperInvoiceDate) {
          shipperInvDateArry.push(dataArray[t].shipperInvoiceDate);
        }
      }

      if (conArry.length > 0) {
        this.ffInvoiceModal.containerDetailsNew = [...new Set(conArry)].toString();
        this.ffInvoiceModal.multipleContainerType = [...new Set(conTypeAry)].toString();
        this.ffInvoiceModal.multipleContainerType_New = [conTypeAry].toString();
        console.log(
          "this.ffInvoiceModal.multipleContainerType=>",
          this.ffInvoiceModal.multipleContainerType
        );
      } else {
        this.ffInvoiceModal.containerDetailsNew = "";
        this.ffInvoiceModal.multipleContainerType = "";
      }

      if (SBNo_Arry.length > 0) {
        this.ffInvoiceModal.BOE =
          [...new Set(SBNo_Arry)].toString() +
          " / " +
          [...new Set(SBNo_DateArry)].toString();
      } else if (this.tallyTableData.length > 0 && this.tallyTableData[0].BOE) {
        this.ffInvoiceModal.BOE = this.tallyTableData[0].BOE;
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
      } else if (this.ccInvoiceTallyData.length > 0 && this.ccInvoiceTallyData[0].BOE) {
        this.ffInvoiceModal.BOE = this.ccInvoiceTallyData[0].BOE;
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
      } else {
        this.ffInvoiceModal.BOE = "";
      }
      if (shiperInvArry.length > 0) {
        this.ffInvoiceModal.shipperInvNo = [...new Set(shiperInvArry)].toString();

        this.ffInvoiceModal.shipperInvNoforTally = [...new Set(shiperInvArry)].toString();
      } else if (this.tallyTableData.length > 0 && this.tallyTableData[0].shipperInvNo) {
        this.ffInvoiceModal.shipperInvNoforTally = this.tallyTableData[0].shipperInvNo;

        this.ffInvoiceModal.shipperInvNo = this.tallyTableData[0].shipperInvNo;
      } else if (
        this.ccInvoiceTallyData.length > 0 &&
        this.ccInvoiceTallyData[0].shipperInvNo
      ) {
        this.ffInvoiceModal.shipperInvNoforTally = this.ccInvoiceTallyData[0].shipperInvNo;

        this.ffInvoiceModal.shipperInvNo = this.ccInvoiceTallyData[0].shipperInvNo;
      } else {
        this.ffInvoiceModal.shipperInvNo = "";
        this.ffInvoiceModal.shipperInvNoforTally = "";
      }
      if (shipperInvDateArry.length > 0) {
        this.ffInvoiceModal.shipperInvDate = [...new Set(shipperInvDateArry)].toString();
        this.ffInvoiceModal.shipperInvDateforTally = [
          ...new Set(shipperInvDateArry),
        ].toString();
      } else if (
        this.tallyTableData.length > 0 &&
        this.tallyTableData[0].shipperInvDate
      ) {
        this.ffInvoiceModal.shipperInvDateforTally = this.tallyTableData[0].shipperInvDate;

        this.ffInvoiceModal.shipperInvDate = this.tallyTableData[0].shipperInvDate;
      } else if (
        this.ccInvoiceTallyData.length > 0 &&
        this.ccInvoiceTallyData[0].shipperInvDate
      ) {
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;

        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;

        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
        this.ffInvoiceModal.shipperInvDateforTally = this.ccInvoiceTallyData[0].shipperInvDate;

        this.ffInvoiceModal.shipperInvDate = this.ccInvoiceTallyData[0].shipperInvDate;
      } else {
        this.ffInvoiceModal.shipperInvDate = "";
        this.ffInvoiceModal.shipperInvDateforTally = "";
      }
      if(this.allContainersDataArray.length>0){
        this.ffInvoiceModal.vessel = this.allContainersDataArray[0].vesselName;
        if(this.ffInvoiceModal.vessel){
          this.ffInvoiceModal.vessel= this.ffInvoiceModal.vessel+"/"+this.allContainersDataArray[0].vesselVoyage;
        }
      }
      if(!this.ffInvoiceModal.vessel){
        this.ffInvoiceModal.vessel=this.mainExecutionDetails[0].leg1_vessel;
        if(this.ffInvoiceModal.vessel){
          this.ffInvoiceModal.vessel= this.ffInvoiceModal.vessel+"/"+this.mainExecutionDetails[0].leg1_voyage;
        }
      }
      if (this.TPTGRNID.length > 0) {
        this.TPTGRNID = this.TPTGRNID.toString();
        this.TPTMERGECONTAINERCHARGEID = [
          ...new Set(this.TPTMERGECONTAINERCHARGEID),
        ].toString();
        this.linkContainer("", "2", this.TPTGRNID, this.TPTMERGECONTAINERCHARGEID);
      }
    },
    deep: true,
  },
  computed: {},
  methods: {
     getJobNatureOfExpenseList() {
      this.is_noe_validation = false; // Reset to false initially
      console.log("allModuleId", this.allModuleId)
      let payload = { module_id: this.ffInvoiceModal.allModuleId, jobNo: this.ffInvoiceModal.mainSalesSeries, moduleType: this.$route.query.ModuleType,  };
      getJobNatureOfExpenseList(payload, (error, result) => {
        if (error) {
          console.log("Catch on getNatureOfExpense Error: ", error);
          this.isSubmited = false;
        } else {
          console.log("NatureOfExpense result:", result);
          if (result && result.natureOfExpense) {
            this.natureOfExpense = result.natureOfExpense;
            this.is_noe_validation = result.is_noe_validation;
            // Also populate natureOfExpenseOptions for the dropdown
            // this.natureOfExpenseOptions = [...this.natureOfExpense];
          }
        }
        this.isLoading = false;
      });
    },
    handleExpensesSaved(expenses) {
      console.log('Expenses saved:', expenses);
      // Handle the saved expenses data
    },

    handleExpenseValidation(validationData) {
      this.expenseValidation = validationData;
      console.log('Expense validation:', validationData);
    },

    // Method to get expense data from child component
    getExpenseData() {
      if (this.$refs.expenseTableComponent) {
        return this.$refs.expenseTableComponent.getAllExpensesData();
      }
      return [];
    },

    // Simple common function to get all expense data
    getExpenseDataSimple() {
      if (!this.$refs.expenseTableComponent) {
        return { all: [], total: 0 };
      }
      
      const allExpenses = this.$refs.expenseTableComponent.getAllExpensesDataComplete();
      const total = allExpenses.reduce((sum, exp) => {
        return sum + (parseFloat(exp.amountToBePaid) || 0) + (parseFloat(exp.amountToBeBilled) || 0);
      }, 0);
      
      return { all: allExpenses, total };
    },
    MainParticular() {
      this.TotalParticularFinalAmount();
    },
    TotalParticularFinalAmount() {
      let TotAmount = 0;
      this.ffTallyInvoiceData.forEach((value, index) => {
        let amount = 0;
        if (isNaN(value.invAmount) || value.invAmount == "") {
          amount = 0;
        } else {
          amount = value.invAmount;
        }
        if (this.totFinalPartAmount == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.totFinalPartAmount = TotAmount;
      });
      // console.log("this.totFinalPartAmount item=>",this.totFinalPartAmount);
      this.$forceUpdate();
    },
    removeParticular(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },

    SelectedAllItem(item, index) {
      console.log("this.ffTallyInvoiceData elet1=>", this.ffTallyInvoiceData);
      this.ffTallyInvoiceData.forEach((ele, val) => {
        if (val == index) {
          console.log("Amount COun elet1=>", ele);
          console.log("Amount COun val=>", val);
          if (ele.slectedStatus == "1") {
            ele.slectedStatus = "0";
          } else {
            ele.slectedStatus = "1";
          }
          console.log("Amount COun elet=>", ele);
        }
      });

      this.totFinalPartAmount = 0;
      this.ffTallyInvoiceData.forEach((ele1, val2) => {
        console.log("Amount COun ele1=>", ele1);
        console.log("Amount COun val2=>", val2);
        if (ele1.slectedStatus == "1") {
          if (this.totFinalPartAmount == 0) {
            this.totFinalPartAmount = parseFloat(ele1.invAmount);
          } else {
            this.totFinalPartAmount =
              parseFloat(this.totFinalPartAmount) + parseFloat(ele1.invAmount);
          }
        }
      });
    },
    SelectAll: function () {
      // console.log("this.allContainersDataArray=>", this.allContainersDataArray);
      // alert("SelectAll");
      this.isCheckAll = !this.isCheckAll;
      this.singleSelectContainer = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.allContainersDataArray) {
          let single_data = "";
          this.singleSelectContainer.push(
            this.allContainersDataArray[key].uniqueContainerId
          );
        }
        // console.log("this.singleSelectContainer=>", this.singleSelectContainer);
      }
    },
    updateSelectAll: function (e, item) {
      //  alert("DeSelectAll");
      // console.log("ids", e)
      // console.log("ids", item)
      if (this.singleSelectContainer.length == this.allContainersDataArray.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }

      const istrue = this.singleSelectContainer.includes(item.uniqueContainerId);
      // console.log("this.singleSelectContainer=>", this.singleSelectContainer);
    },
    getGRNpdf(item) {
      window.open(`${this.docURL}/` + item);
    },
    removeContainerType(index) {
      this.allContainersDataArray.splice(index, 1);
    },
    pushSplitedContainers() {
      let array1 = this.splitedOrMergedContainers.filter((x) => {
        return x.uniqueContainerId == this.splitOrMergeConNo;
      });

      if (array1.length > 0) {
        let array2 = this.allContainersDataArray.filter((x) => {
          return x.uniqueContainerId == this.splitOrMergeConNo;
        });
        if (array2.length <= 0) {
          array1[0]["onlyTPT"] = "1";
          this.allContainersDataArray.push(...array1);
          console.log(array1);
        }
      }
      console.log(this.allContainersDataArray);
    },
    linkContainer(item, id, GR, mergeConCharge) {
      this.TPTGRNDATA = [];
      this.TPTMergeConInvoiceTallyData = [];
      this.ffTallyInvoiceData = this.ffTallyInvoiceData.filter((el) => el.color !== "1");
      this.isLoading = true;
      let payload = {};
      if (id == "1") {
        payload = {
          fromSplitMergeAssignId: item.fromSplitMergeAssignId,
          splitedToOrMergedToAssignId: item.splitedToOrMergedToAssignId,
          uniqueContainerId: item.uniqueContainerId,
          containerNo: item.containerNo,
          tptGrnId: item.tptGrnId,
          fetchId: id,
        };
      } else {
        payload = {
          tptGrnId: GR,
          mergeConCharge: mergeConCharge,
          fetchId: id,
          job: this.newJobType,
          getCCSplitChargesId: this.mainExecutionDetails[0].splitFromId,
        };
      }
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/linkContainerForBilling_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "sfsfrererere");
            if (data.TPTGRNDATA.length > 0) {
              this.TPTGRNDATA = data.TPTGRNDATA;
              this.TOLLPRICE = parseInt(data.TPTGRNDATA[0].tollPrice);
            } else {
              this.TOLLPRICE = 0;
            }
            if (data.TPTMergeConInvoiceTallyData.length > 0) {
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              //   let TCUR = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTMergeConInvoiceTallyData.length > 0) {
                this.TPTMergeConInvoiceTallyData = data.TPTMergeConInvoiceTallyData;

                for (let p = 0; p < this.TPTMergeConInvoiceTallyData.length; p++) {
                  TPTParti = this.TPTMergeConInvoiceTallyData[p].particulars.split(",");
                  INVID = this.TPTMergeConInvoiceTallyData[p].invoiceId;
                  TPTCon = this.TPTMergeConInvoiceTallyData[p].containerType.split(",");
                  TPTQUN = this.TPTMergeConInvoiceTallyData[p].quantity.split(",");
                  UNT = this.TPTMergeConInvoiceTallyData[p].unit.split(",");
                  TPTSelO = this.TPTMergeConInvoiceTallyData[p].quotationRate.split(",");
                  TPTSF = this.TPTMergeConInvoiceTallyData[p].sellingRateFinal.split(",");
                  TPTINV = this.TPTMergeConInvoiceTallyData[p].finalRateWithoutTax.split(
                    ","
                  );
                  TPTRE = this.TPTMergeConInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0",
                        color: "1",
                      };
                      this.ffTallyInvoiceData.push(obj2);
                      //  this.tptCheckDone = 1;
                    });
                  }
                }
              }
            }
            if (data.CCMergeConInvoiceTallyData.length > 0) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.CCMergeConInvoiceTallyData.length > 0) {
                CCParti = data.CCMergeConInvoiceTallyData[0].particulars.split(",");
                CCCon = data.CCMergeConInvoiceTallyData[0].containerType.split(",");
                CCQuantity = data.CCMergeConInvoiceTallyData[0].quantity.split(",");
                CCSellingR = data.CCMergeConInvoiceTallyData[0].quotationRate.split(",");
                CCSF = data.CCMergeConInvoiceTallyData[0].sellingRateFinal.split(",");
                if (data.CCMergeConInvoiceTallyData[0].exchRate) {
                  EXRTCC = data.CCMergeConInvoiceTallyData[0].exchRate.split(",");
                } else {
                  EXRTCC = [];
                }
                CCInvAmt = data.CCMergeConInvoiceTallyData[0].finalRateWithoutTax.split(
                  ","
                );
                CCCurrency = data.CCMergeConInvoiceTallyData[0].currency.split(",");
                UN = data.CCMergeConInvoiceTallyData[0].unit.split(",");

                CCRemark = data.CCMergeConInvoiceTallyData[0].remark.split(",");
              } else {
                //  this.alert.content = "Charges Not Received From CC";
                //         this.$refs["addPop"].open();
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                    exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
                    slectedStatus: "0",
                    color: "1",
                  };

                  this.ffTallyInvoiceData.push(obj1);

                  // this.CCCheckDone = 1;
                });
              }
            }
            if (id == "1") {
              this.getData();
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {});
    },
    fetchDataContainerwise() {
      this.isLoading = true;
      let payload = {
        allModuleId: this.allModuleIdContainer,
        JOB: this.JOB,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getDataContainerwiseTally.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "sfsfrererere");

            if (data.allContainersDataArray.length > 0) {
              this.allContainersDataArray = data.allContainersDataArray;
            }
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }
            if (data.LocationDetailsFinal.length > 0) {
              this.pickUpList = data.LocationDetailsFinal;
              this.handoverList = data.LocationDetailsFinal;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    closeBill(id) {
      this.selectedAllModuleId = id;

      this.alert.content = "Are you sure to close Assignment Billing ?";
      this.$refs["addPopClose"].open();
    },
    closeBillOk(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    changeOtherClient() {
      let arryDone = this.clientData.filter((x) => {
        return x.clientId == this.ffInvoiceModal.clientId;
      });
      // alert(arryDone);
      console.log(arryDone);
      if (arryDone.length > 0) {
        this.ffInvoiceModal.clientName = arryDone[0].clientName;
        this.ffInvoiceModal.contact = arryDone[0].phoneKYC;
        this.ffInvoiceModal.clientgst = arryDone[0].gstCode + arryDone[0].GSTN;
        this.ffInvoiceModal.stateName = arryDone[0].stateName;
        this.ffInvoiceModal.adress = arryDone[0].corporateAddress;
        this.ffInvoiceModal.fromAgentColoderTable = arryDone[0].fromAgentColoderTable;
      }
      if (this.mainExecutionDetails.length > 0) {
        if (
          this.mainExecutionDetails[0].clientId &&
          (this.mainExecutionDetails[0].clientId == this.ffInvoiceModal.clientId ||
            this.mainExecutionDetails[0].exporterClientId == this.ffInvoiceModal.clientId)
        )
          this.otherClientChecked = false;
      }
      //  this.ffInvoiceModal.jobNo="-/-/" + this.UserDetailForBillingLoc[0].BranchCode
    },
    getAddedBillingBranchInv() {
      let payload = {
        billingLocationId: this.ffInvoiceModal.billingLocationId,
      };

      let options = {
        method: "PUT",
        url: `${URL_BASE}/Api_TallyBilling/getExistingTallyData.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.existingBillingLocationData.length > 0) {
              this.ffInvoiceModal.tallyBillingSeries = parseInt(
                data.existingBillingLocationData.length
              );
            } else {
              this.ffInvoiceModal.tallyBillingSeries = 1;
            }
          }
          // $("#loaderS").css("display", "none");
          // $("#addButtonLoaderS").css("display", "block");

          // this.getData();
          // this.$router.push({
          //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
          // });
        })
        .catch((error) => {});
    },

    getBillingBranch() {
      let arryNewBillBranch = this.billingLocationData.filter((x) => {
        return x.billingLocationId == this.ffInvoiceModal.billingLocationId;
      });

      if (arryNewBillBranch.length > 0) {
        this.ffInvoiceModal.billingLocationId = arryNewBillBranch[0].billingLocationId;
        this.ffInvoiceModal.billingLocationName = arryNewBillBranch[0].billingLocation;
      }
      // this.getAddedBillingBranchInv();
    },
    copyCharges() {
      if (this.selectedTallyInv == false) {
        this.showMoreItem();
      }
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          allModuleId: this.ffInvoiceModal.allModuleId,
          approvalMail: "approvalMail",
          executionNo: this.ffInvoiceModal.jobNo,
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/sendApprovalRevisedBilling.php`,
            data: JSON.stringify(newData),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.getData();
              //this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    openPop() {
      if (this.ffInvoiceModal.sentForRevisedApproval == "1") {
        this.confirm.contentHtml = "Already Sent  for Approval..?";
      } else {
        this.confirm.contentHtml = "Send   for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    changeClient() {
      // let arryDone = this.billingTableData.filter(x => {
      //   return x.invoiceForClient == this.ffInvoiceModal.invoiceForClient;
      // });
      // if(arryDone.length>0){
      //   let contaierAdded=arryDone
      //   let particularsAdded=
      //   console.log(arryDone)
      //  this.ffTallyInvoiceData.map(x => {
      //         if (x.ffType == "TRANSPORT CHARGES") {
      //           this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
      //         }
      //         if (x.ffType == "TOLL CHARGES") {
      //           this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
      //         }
      //         let dummy = parseInt(x.invAmount) + total;
      //         total = dummy;
      //       });
      // }

      if (this.ffInvoiceModal.invoiceForClient == "1") {
        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].exporter;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].exporterClientId;

        // this.ffInvoiceModal.contact=arryDone[0].phoneKYC
        //      this.ffInvoiceModal.clientgst=arryDone[0].gstCode + arryDone[0].GSTN
        //      this.ffInvoiceModal.stateName=arryDone[0].stateName
        //      this.ffInvoiceModal.adress=arryDone[0].corporateAddress
      } else {
        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].clientName;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].clientId;
      }
    },
    reload() {
      // Object.keys(this.ffInvoiceModal).map(x => {
      //   this.ffInvoiceModal[x] = "";
      // });
    },
    showMoreItem() {
      Object.keys(this.ffInvoiceModal).map((x) => {
        this.ffInvoiceModal[x] = "";
      });
      this.getData();

      this.newJobType = [];
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },
    goToMain() {
      this.ffInvoiceModal.billingId = "";
    },
    getDuplicateLedger(item, index) {
      //  var x = document.getElementsByClassName("parti")[index];
      // var y=x.getElementsByClassName("text");
      // // y[0].outerHTML=""
      // y[0].outerText=item.ffType
      // console.log(x,"jhhhhhhhhhhhhhh",y[0].outerText)
      // let alreadyLedger = item.ffType;
      // let array = this.ffTallyInvoiceData.filter((x) => {
      //   return x.ffType == alreadyLedger;
      // });
      // if (array.length > 1) {
      //   this.alert.content = alreadyLedger + " Already Exists..! ";
      //   this.$refs["addPopMaxPer"].open();
      // }
    },
    getBillData(item) {
      let shipmentType = this.mainExecutionDetails[0].shipmentType=="2"?"Air":"Sea";
      this.getLedgerList(item.jobType.toString(),shipmentType,this.mainExecutionDetails[0].transportType);
      this.ffInvoiceModal.billingId = item.billingId;
      this.showMoreNewItem = true;
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });

      let CCParti = [];
      let CCCon = [];
      let CCSellingR = [];
      let CCSF = [];
      let CCInvAmt = [];
      let exchRateArry = [];
      let CCCurrency = [];
      let CCQuantity = [];
      let CCRemark = [];
      let UN = [];

      if (item.particulars != null) {
        CCParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        CCCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        CCQuantity = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        CCSellingR = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        CCSF = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.finalRateWithoutTax != null) {
        CCInvAmt = item.finalRateWithoutTax.split(",");
      }
      if (item.exchRate) {
        exchRateArry = item.exchRate.split(",");
      }
      if (item.currency != null) {
        CCCurrency = item.currency.split(",");
      }
      if (item.remark != null) {
        CCRemark = item.remark.split(",");
      }

      if (CCParti.length > 0) {
        CCParti.map((x, index) => {
          let obj1 = {
            ffType: x,
            containerType: CCCon[index],
            quantity: CCQuantity[index],
            ffSellingRate: CCSellingR[index],
            exchRate: exchRateArry.length > 0 ? exchRateArry[index] : "1",
            sellingRateFinal: CCSF[index],
            unit: UN[index],
            invAmount: CCInvAmt[index],
            currency: CCCurrency[index],
            remark: CCRemark[index],
            slectedStatus: "0",
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });

        this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    getAllTallyData() {
      this.ffTallyInvoiceData = [];

      this.isLoading = true;
      let vehicle_drive = {
        allModuleId: this.ffInvoiceModal.allModuleId,
        InvTallyId: this.$route.query.InvTallyId,
        itemCode: "itemCode",
        ccCheck: this.newJobType.indexOf("CC"),
        tptCheck: this.newJobType.indexOf("TPT"),
        ffCheck: this.newJobType.indexOf("FF"),
        CCCheckDone: this.CCCheckDone,
        ffCheckDone: this.ffCheckDone,
        TPTCheckDone: this.TPTCheckDone,
        splitFromId: this.mainExecutionDetails[0].splitFromId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/fetchAllConInvoiceTallyData.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            let CON_NO = [];
            let CONTYPE = [];
            // For CC
            if (this.newJobType.indexOf("CC") >= 0) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.ccInvoiceTallyData.length > 0) {
                this.ccInvoiceTallyData = data.ccInvoiceTallyData;
                this.ffInvoiceModal.POR = this.ccInvoiceTallyData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.ccInvoiceTallyData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.ccInvoiceTallyData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.ccInvoiceTallyData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();

                CCParti = this.ccInvoiceTallyData[0].particulars.split(",");
                CCCon = this.ccInvoiceTallyData[0].containerType.split(",");
                CCQuantity = this.ccInvoiceTallyData[0].quantity.split(",");
                CCSellingR = this.ccInvoiceTallyData[0].quotationRate.split(",");
                CCSF = this.ccInvoiceTallyData[0].sellingRateFinal.split(",");
                if (this.ccInvoiceTallyData[0].exchRate) {
                  EXRTCC = this.ccInvoiceTallyData[0].exchRate.split(",");
                } else {
                  EXRTCC = [];
                }
                CCInvAmt = this.ccInvoiceTallyData[0].finalRateWithoutTax.split(",");
                CCCurrency = this.ccInvoiceTallyData[0].currency.split(",");
                UN = this.ccInvoiceTallyData[0].unit.split(",");

                CCRemark = this.ccInvoiceTallyData[0].remark.split(",");
                if (this.ccInvoiceTallyData[0].blNo) {
                  this.ffInvoiceModal.blNo = this.ccInvoiceTallyData[0].blNo;
                }
                if (this.ccInvoiceTallyData[0].vessel) {
                  this.ffInvoiceModal.vessel = this.ccInvoiceTallyData[0].vessel;
                }
                if (this.ccInvoiceTallyData[0].shippingLine) {
                  this.ffInvoiceModal.shippingLine = this.ccInvoiceTallyData[0].shippingLine;
                }
                if (this.ccInvoiceTallyData[0].weight) {
                  this.ffInvoiceModal.weight = this.ccInvoiceTallyData[0].weight;
                }
              } else {
                //  this.alert.content = "Charges Not Received From CC";
                //         this.$refs["addPop"].open();
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                    exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
                    slectedStatus: "0",
                  };

                  this.ffTallyInvoiceData.push(obj1);

                  // this.CCCheckDone = 1;
                });
              }
            }

            // For FF
            if (this.newJobType.indexOf("FF") >= 0) {
              let TParti = [];
              let TCon = [];
              let TSelO = [];
              let TSF = [];
              let TINV = [];
              let TCUR = [];
              let TRE = [];
              let QUN = [];
              let FFINVID = [];
              let UNF = [];
              let EXRTFF = [];

              if (data.tallyTableData.length > 0) {
                this.tallyTableData = data.tallyTableData;

                this.ccInvoiceTallyData = data.ccInvoiceTallyData;
                // this.ffInvoiceModal.shipperInvNoforTally =this.tallyTableData[0].shipperInvNo
                // this.ffInvoiceModal.shipperInvDateforTally =this.tallyTableData[0].shipperInvDate
                // this.ffInvoiceModal.shipperInvNo =this.tallyTableData[0].shipperInvNo;

                //  this.ffInvoiceModal.shipperInvDate=this.tallyTableData[0].shipperInvDate;
                // this.ffInvoiceModal.BOE =this.tallyTableData[0].BOE;
                if (this.tallyTableData[0].blNo) {
                  this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
                }
                if (this.tallyTableData[0].vessel) {
                  this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
                }
                if (this.tallyTableData[0].shippingLine) {
                  this.ffInvoiceModal.shippingLine = this.tallyTableData[0].shippingLine;
                }
                if (this.tallyTableData[0].weight) {
                  this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
                }

                if (this.tallyTableData[0].containerDetails) {
                  this.ffInvoiceModal.containerDetailsNew = this.tallyTableData[0].containerDetails;
                }

                if (this.tallyTableData[0].multipleContainerType) {
                  this.ffInvoiceModal.multipleContainerType = this.tallyTableData[0].multipleContainerType;
                }

                if (this.tallyTableData[0].BOE) {
                  this.ffInvoiceModal.BOE = this.tallyTableData[0].BOE.replace(
                    "00:00:00",
                    ""
                  );

                  this.allContainersDataArray[0].shippingBillNo = this.ffInvoiceModal.BOE.split(
                    "/"
                  )[0];
                  this.allContainersDataArray[0].shippingBillDate = this.ffInvoiceModal.BOE.split(
                    "/"
                  )[1];
                }

                // console.log(this.tallyTableData,"iuyyghjkh")

                this.ffInvoiceModal.POR = this.tallyTableData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.tallyTableData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.tallyTableData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.tallyTableData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();

                for (let r = 0; r < this.tallyTableData.length; r++) {
                  FFINVID = this.tallyTableData[r].InvTallyId;
                  TParti = this.tallyTableData[r].particulars.split(",");
                  TCon = this.tallyTableData[r].containerType.split(",");
                  QUN = this.tallyTableData[r].quantity.split(",");
                  TSelO = this.tallyTableData[r].quotationRate.split(",");
                  TSF = this.tallyTableData[r].sellingRateFinal.split(",");
                  TINV = this.tallyTableData[r].finalRateWithoutTax.split(",");
                  TCUR = this.tallyTableData[r].currency.split(",");
                  TRE = this.tallyTableData[r].remark.split(",");
                  UNF = this.tallyTableData[r].unit.split(",");
                  if (this.tallyTableData[0].exchRate) {
                    EXRTFF = this.tallyTableData[r].exchRate.split(",");
                  } else {
                    EXRTFF = [];
                  }

                  if (TParti.length > 0) {
                    TParti.map((y, index) => {
                      let obj = {
                        ffType: y,
                        containerType: TCon[index],
                        quantity: QUN[index],
                        ffSellingRate: TSelO[index],
                        exchRate: EXRTFF[index],

                        sellingRateFinal: TSF[index],
                        unit: UNF[index],
                        invAmount: TINV[index],
                        currency: TCUR[index],
                        remark:
                          TINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TRE[index]
                            : TRE[index],
                        mainffId: FFINVID,
                        slectedStatus: "0",
                      };
                      this.ffTallyInvoiceData.push(obj);

                      // this.ffCheckDone = 1;
                    });
                  }
                }
              } else {
                //  this.alert.content = "Charges Not Received From FF";
                //         this.$refs["addPop"].open();
              }
            } else {
              this.ffCheckDone = 0;
            }

            // for TPT
            if (this.newJobType.indexOf("TPT") >= 0) {
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              //   let TCUR = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTInvoiceTallyData.length > 0) {
                this.TPTInvoiceTallyData = data.TPTInvoiceTallyData;
                this.ffInvoiceModal.pickup = this.TPTInvoiceTallyData[0].fromLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.Handover = this.TPTInvoiceTallyData[0].toLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.factoryLoc = this.TPTInvoiceTallyData[0].StuffingLocation.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                for (let p = 0; p < this.TPTInvoiceTallyData.length; p++) {
                  TPTParti = this.TPTInvoiceTallyData[p].particulars.split(",");
                  INVID = this.TPTInvoiceTallyData[p].invoiceId;
                  TPTCon = this.TPTInvoiceTallyData[p].containerType.split(",");
                  TPTQUN = this.TPTInvoiceTallyData[p].quantity.split(",");
                  UNT = this.TPTInvoiceTallyData[p].unit.split(",");
                  TPTSelO = this.TPTInvoiceTallyData[p].quotationRate.split(",");
                  TPTSF = this.TPTInvoiceTallyData[p].sellingRateFinal.split(",");
                  TPTINV = this.TPTInvoiceTallyData[p].finalRateWithoutTax.split(",");
                  TPTRE = this.TPTInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0",
                      };
                      this.ffTallyInvoiceData.push(obj2);
                      //  this.tptCheckDone = 1;
                    });
                  }
                }
              } else {
                //  this.alert.content = "Charges Not Received From TPT";
                //         this.$refs["addPop"].open();
              }
            } else {
              this.tptCheckDone = 0;
            }

            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }

            this.isLoading = false;
          }
          if (this.ffTallyInvoiceData.length > 0) {
            this.MainParticular();
            this.getOceanFreight();
          }
        })
        .catch((error) => {});
    },
    getRTBIExistInvoiceDetails() {
      this.RTBI_InvBtnRejection_btnFlag = false;
      let payload = {
        FF: this.newJobType.indexOf("FF") >= 0 ? 1 : 0,
        CC: this.newJobType.indexOf("CC") >= 0 ? 1 : 0,
        TPT: this.newJobType.indexOf("TPT") >= 0 ? 1 : 0,
        MISC: this.newJobType.indexOf("MISC") >= 0 ? 1 : 0,
        IB: this.newJobType.indexOf("IB") >= 0 ? 1 : 0,
        YARD: this.newJobType.indexOf("YARD") >= 0 ? 1 : 0,
        Selected_JOBTYPE: this.newJobType.toString(),
        JOBID: this.$route.params.billingId,
        JOBNO: this.mainExecutionDetails[0].mainSalesSeries,
        itemCode: "getRTBIExistInvoiceDetails",
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.find == 1 && data.RTBIListFLAG == true) {
            this.InvBtnRejection_btnFlag = data.btnFlag;
            // this.alert.content = data.RTBIListMSG;
            // this.$refs["addPop"].open();
          }
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
    getLedgerList(JobType,ShipmentType,ModuleType){
      const storePromises = [
          this.$store.dispatch(
          "common/setAllLedgerList",
          JSON.stringify({
            itemCode: "LedgerList",
            JobType:JobType,
            ShipmentType:ShipmentType,
            ModuleType:ModuleType,
            isLedgerActive:'1',
          })
        ),
      ];
      // Function to introduce a delay
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      Promise.all(storePromises)
        .then(() => delay(5000)) // Wait for 5 seconds
        .then(() => {
        
        })
        .catch((error) => {
          console.error("Error dispatching store actions:", error);
        });
    },
    jobTypeSelect(value, index) {
      this.singleSelectContainer = [];
      this.TPTGRNID = [];
      this.TPTGRNDATA = [];
      this.TPTMERGECONTAINERCHARGEID = [];
      this.selectedValue = value;
      this.ffInvoiceModal.jobTypeName = this.newJobType;
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
      console.log('mainExecutionDetails=>',this.mainExecutionDetails)
      let shipmentType = this.mainExecutionDetails[0].shipmentType=="2"?"Air":"Sea";
      this.getLedgerList(this.newJobType.toString(),shipmentType,this.mainExecutionDetails[0].transportType);
      if (this.newJobType.length > 0) {
        this.getRTBIExistInvoiceDetails();
      }
      let selectedJob = this.newJobType.toString();
      if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("CC") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,CC,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("FF") && this.newJobType.includes("TPT")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("CC") && this.newJobType.includes("TPT")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "CC,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("FF") && this.newJobType.includes("CC")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,CC" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("FF")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("CC")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "CC" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("TPT")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.multiTPT = onlyFF.length;
        } else {
          this.ffInvoiceModal.multiTPT = "";
        }
      } else {
        console.log("no job");
      }

      this.getAllTallyData();
      // this.getData();
      //this.getAddedBillingBranchInv();
    },
    getCommonDetails() {
      let payload = {};
      payload = {
        itemCode: "getJobCommonDetails",
        allModuleId: this.$route.params.billingId,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.CommonFLAG == 1) {
            this.common_details.oe_oceanf_rate = data.getJobCommonDetails.oe_oceanf_rate;
            this.common_details.oe_oceanf_sell_rate =
              data.getJobCommonDetails.oe_oceanf_sell_rate;
            this.common_details.oe_fk_currency_id =
              data.getJobCommonDetails.oe_fk_currency_id;
            this.common_details.oe_oceanf_remark =
              data.getJobCommonDetails.oe_oceanf_remark;
          }
        })
        .catch((error) => {
          console.log("Catch on getCommonDetails Error: ", error);
        });
    },
    checkBSRate() {
      let rateDifference =
        this.common_details.oe_oceanf_sell_rate - this.common_details.oe_oceanf_rate;
      let BS_MSG = "";
      if (this.common_details.oe_oceanf_rate > this.common_details.oe_oceanf_sell_rate) {
        BS_MSG = `Selling Rate is ${rateDifference} less than Buying Rate. Consider selling.`;
      } else if (
        this.common_details.oe_oceanf_rate < this.common_details.oe_oceanf_sell_rate
      ) {
        BS_MSG = `Buying Rate is ${rateDifference} less than Selling Rate. Consider buying.`;
      } else {
        BS_MSG = "Buying and Selling Rate are equal. Take appropriate action.";
      }
      this.common_details.oceanFreightRate_err = BS_MSG;
      this.alert.content = BS_MSG;
      this.$refs["addPop"].open();
    },
    getOceanFreight() {
      this.getCommonDetails();
      this.oceanFreight = [];
      if (this.newJobType.indexOf("FF") >= 0) {
        this.ffTallyInvoiceData.forEach((items, inds) => {
          this.oceanFreight.push(items.ffType);
        });
      }

      this.oceanFreight = [...new Set(this.oceanFreight)];
      console.log("new array:", this.oceanFreight, this.ffInvoiceModal.jobType);
      if (this.PreviousTallyItemTable.length > 0) {
        // this.getPreviousTallyItemTableData();
      }
    },

    getPreviousTallyData(pre_item) {
      let particulars = pre_item.particulars.split(",");
      
      console.log("pre_item=>", pre_item,particulars.length);
      if (particulars.length > 0) {
        this.getPreviousTallyItemTableDataInv(pre_item, particulars);
      }
      // this.ffInvoiceModal.fromAgentColoderTable = pre_item.fromAgentColoderTable;
      // this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      // this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      // this.ffInvoiceModal.billingLocationId = pre_item.billingLocationId;
      // this.ffInvoiceModal.billingLocationName = pre_item.billingLocationName;
      // this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      // this.ffInvoiceModal.shipperInvDateforTally = pre_item.shipperInvDateforTally;
      // this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      // this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      // this.ffInvoiceModal.stateName = pre_item.stateName;
      // this.ffInvoiceModal.clientgst = pre_item.clientgst;
      // this.ffInvoiceModal.grnNo = pre_item.grnNo;
      // this.ffInvoiceModal.pickup = pre_item.pickup;
      // this.ffInvoiceModal.Handover = pre_item.Handover;
      // this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobNo = pre_item.jobNo;
      // this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      // this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      // this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      // this.ffInvoiceModal.weight = pre_item.weight;
      // this.ffInvoiceModal.vessel = pre_item.vessel
      //   ? pre_item.vessel
      //   : this.ffInvoiceModal.vessel;
      // this.ffInvoiceModal.blNo = pre_item.blNo;
      // this.ffInvoiceModal.BOE = pre_item.BOE;
      // this.ffInvoiceModal.clientId = pre_item.clientId;
      // this.ffInvoiceModal.clientName = pre_item.clientName;
      // this.ffInvoiceModal.contact = pre_item.contact;
      // this.ffInvoiceModal.adress = pre_item.adress;
      // this.ffInvoiceModal.POR = pre_item.POR;
      // this.ffInvoiceModal.LP = pre_item.LP;
      // this.ffInvoiceModal.POD = pre_item.POD;
      // this.ffInvoiceModal.FPOD = pre_item.FPOD;
      // this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
    },
    getPreviousTallyItemTableDataInv(pre_item, particulars) {
      if (particulars.length > 0) {
        this.ffTallyInvoiceData = [];
        let TPTParti = [];
        let TPTCon = [];
        let TPTSelO = [];
        let TPTSF = [];
        let TPTINV = [];
        let TPTCURRENCY =[];
        let TPTEXCRate =[];
        //   let TCUR = [];
        let TPTRE = [];
        let TPTQUN = [];
        let INVID = [];
        let UNT = [];
        TPTParti = pre_item.particulars.split(",");
        INVID = pre_item.invoiceId;
        TPTCon = pre_item.containerType.split(",");
        TPTQUN = pre_item.quantity.split(",");
        UNT = pre_item.unit.split(",");
        TPTSelO = pre_item.quotationRate.split(",");
        TPTSF = pre_item.sellingRateFinal.split(",");
        TPTINV = pre_item.finalRateWithoutTax.split(",");
        TPTRE = pre_item.remark.split(",");
        TPTCURRENCY = pre_item.currency.split(",");
        TPTEXCRate = pre_item.exchRate.split(",");
        
        console.log("TPTCURRENCY=>",TPTCURRENCY)
        console.log("TPTEXCRate=>",TPTEXCRate)
        if (TPTParti.length > 0) {
          TPTParti.map((z, index) => {
            let obj2 = {
              ffType: z,
              containerType: TPTCon[index],
              quantity: TPTQUN[index],
              ffSellingRate: TPTSelO[index],
              exchRate: TPTEXCRate[index],
              sellingRateFinal: TPTSF[index],
              unit: UNT[index],
              invAmount: TPTINV[index],
              currency: TPTCURRENCY[index],

              remark:
                TPTINV[index] == "Charges As Per Receipt"
                  ? "Charges As Per Receipt " + " && " + TPTRE[index]
                  : TPTRE[index],
              mainffId: INVID,
              slectedStatus: "0",
              color: "",
            };
            this.ffTallyInvoiceData.push(obj2);
            //  this.tptCheckDone = 1;
          });
        }
      }
      console.log("this.ffTallyInvoiceData=>",this.ffTallyInvoiceData)
    },
    getServicesData() {
      this.showSegmentArray = [];
      let jobArry = this.mainExecutionDetails[0].jobType.split(",");
      jobArry.map((x) => {
        let obj = {
          value: x,
          show:
            x == "FF"
              ? "Freight Forwarding(" + x + ")"
              : x == "CC"
              ? "Custom Clearance(" + x + ")"
              : x == "TPT"
              ? "Transportation(" + x + ")"
              : "",
          flex: "20",
        };
        this.showSegmentArray.push(obj);
      });
      // this.showSegmentArray = [
      //   {
      //     value: "FF",
      //     show: "Freight Forwarding(FF)",
      //     flex: "20"
      //   },
      //   {
      //     value: "CC",
      //     show: "Customs Clearance(CC)",
      //     flex: "20"
      //   }
      // ];
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });

      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }

      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );

      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    getFinalAmount(ind) {
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);
      if (
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) <
        parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)
      ) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },
    checkForDuplicates() {
      // Create an object to store occurrences
      const occurrences = {};
      let duplicateFound = false;

      // Loop through each item in the data
      for (const item of this.ffTallyInvoiceData) {
        // Create a unique key based on containerType, ffType, and sellingRateFinal
        const key = `${item.containerType}-${item.ffType}-${item.sellingRateFinal}`;
        
        // Check if the key already exists in the occurrences object
        if (occurrences[key]) {
          // Set the duplicate flag and populate alert content
          this.alert.content = `Duplicate found for: Particular: ${item.ffType}, Container Type: ${item.containerType}, Selling Rate: ${item.sellingRateFinal}`;
          duplicateFound = true;
          break;  // Stop the loop once a duplicate is found
        } else {
          // Otherwise, add the key to the occurrences object
          occurrences[key] = true;
        }
      }
      console.log(occurrences,'occurrences')
      // If a duplicate was found, trigger the alert
      if (duplicateFound) {
        // alert(this.alert.content);  // Optional: you can keep this or remove it
        // this.$refs["addValidateClose"].open();  // Open the modal popup for the alert
        // this.openDialog();
        this.$refs["addPop"].open();
        return false;  // Prevent further processing
      }

      // If no duplicates found, allow further processing
      return true;
    },
    validateBillingParticulars(){
      let flag = this.checkForDuplicates();
      if(!flag) {
        return;
      }
      this.addDataTally();
    },
    openDialog() {
      // this.$refs.customDialog.show();
    },
    confirmBilling() {
      this.addDataTally(); // Call the method to continue billing
      this.close(); // Close the dialog after confirming
    },
    close() {
      // this.$refs.customDialog.hide();
    },
    handleBillingClose(){
      this.$refs["addValidateClose"].close();
    },
    addDataTally() {
      this.ffInvoiceModal.containerDetails = [];
      if (this.ffInvoiceModal.containerDetailsNew) {
        let selectedCon = this.ffInvoiceModal.containerDetailsNew.split(",");
        let selectedConType = this.ffInvoiceModal.multipleContainerType.split(",");

        for (let w = 0; w < selectedCon.length; w++) {
          let objCon = {
            containerNoFF: selectedCon[w],
            containerTypeFF: selectedConType[w],
          };
          this.ffInvoiceModal.containerDetails.push(objCon);
        }
      }
      if (this.ffInvoiceModal.containerDetails.length <= 0) {
        this.alert.content = "Select At least 1 Container";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.newJobType.length <= 0) {
        this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop"].open();
        return false;
      }
      if (this.ffInvoiceModal.billingLocationId == "") {
        this.alert.content = "Please Select Billing Location";
        this.$refs["addPop"].open();
        return false;
      }

      this.alert.content =
        "Data will be added to " + this.ffInvoiceModal.billingLocationName;
      this.$refs["addPopTally"].open();
    },

    submitInvoice(type) {
      let id = "1";

      if (type != "cancel") {
        this.ffInvoiceModal.jobTypeName = this.newJobType;
        for (let t = 0; t < this.ffTallyInvoiceData.length; t++) {
          if (
            !this.ffTallyInvoiceData[t].slectedStatus ||
            this.ffTallyInvoiceData[t].slectedStatus == "0"
          ) {
            this.ffTallyInvoiceData.splice(t, 1);
          }
        }

        if (this.ffTallyInvoiceData.length > 0) {
          for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
            if (
              !this.ffTallyInvoiceData[r].slectedStatus ||
              this.ffTallyInvoiceData[r].slectedStatus == "0"
            ) {
              this.ffTallyInvoiceData.splice(r, 1);

              return false;
              break;
            } else {
              if (
                !this.ffTallyInvoiceData[r].ffType &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].quantity &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].ffSellingRate &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].sellingRateFinal &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].unit &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].invAmount &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].currency &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else {
                console.log("All fields are Entered");
              }
            }
          }
        } else {
          this.alert.content = "Please Add minimum 1 Chagers to Tally";
          this.$refs["addPop"].open();
          return false;
          return false;
        }

        if (this.ffInvoiceModal.clientName == "") {
          this.alert.content = "Please Enter Client Name";
          this.$refs["addPop"].open();
          return false;
        }
        this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;

        this.ffInvoiceModal["TPTGRNDATA"] = this.TPTGRNDATA;

        this.ffInvoiceModal["buttonId"] = id;
        let total = 0;

        this.ffTallyInvoiceData.map((x) => {
          if (x.ffType == "TRANSPORT CHARGES") {
            this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
          }
          if (x.ffType == "TOLL CHARGES") {
            this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
          }
          let dummy = parseFloat(x.invAmount) + total;
          total = dummy;
        });

        this.ffInvoiceModal.totalAmount = total;
        this.ffInvoiceModal["manualBilling"] = "0";
        if (this.otherClientChecked == true) {
          this.ffInvoiceModal["otherClientChecked"] = "Y";
        }
        this.ffInvoiceModal["singleSelectContainer"] = this.singleSelectContainer;

        if (this.validateInvoice != false) {
          this.ffInvoiceModal.common_details = this.common_details;
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/addBillingTally_NewV3.php`,
            data: JSON.stringify(this.ffInvoiceModal),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };
          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  this.alert.content = "Added Successfully";
                } else {
                  this.alert.content = "Data Updated Successfully";
                }
                $("#addButtonLoader").css("display", "block");
                $("#loader").css("display", "none");
                this.close(); 
                this.$refs["addPop"].open();
                this.close(); 
                this.getData(id);
                this.slectedAllStatus = "0";
                // this.showMoreNewItem = false;
                //   location.reload();
              }
            })
            .catch((err) => {
              throw err;
            });
        }
      }
    },

    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    SelectedAll() {
      for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
        if (this.slectedAllStatus == "1") {
          this.ffTallyInvoiceData[r].slectedStatus = "1";
        } else {
          this.ffTallyInvoiceData[r].slectedStatus = "0";
        }
      }
      console.log(this.ffTallyInvoiceData);
      // if(this.ffTallyInvoiceData[index].slectedStatus && this.ffTallyInvoiceData[index].slectedStatus=='1'){
      // console.log("activate")
      // this.ffTallyInvoiceData[index].slectedStatus=1;
      // }else{
      // console.log("dactivate",this.ffTallyInvoiceData[index].slectedStatus)
      //  this.ffTallyInvoiceData[index].slectedStatus=0;
      // }
    },

    removeGRN(index, item) {
      let i = 0;
      while (i < this.ffTallyInvoiceData.length) {
        let x = item.invoiceId;
        if (this.ffTallyInvoiceData[i].mainffId == x) {
          this.ffTallyInvoiceData.splice(i, 1);
        } else {
          ++i;
        }
      }

      this.TPTGRNDATA.splice(index, 1);
      console.log(this.TPTGRNDATA);
    },

    removeFFContainer(index, itemAll) {
      // console.log(itemAll);
      let p = 0;
      while (p < this.ffTallyInvoiceData.length) {
        let y = itemAll.FFInvIdId;
        if (this.ffTallyInvoiceData[p].mainffId == y) {
          this.ffTallyInvoiceData.splice(p, 1);
        } else {
          ++p;
        }
      }
      this.ffInvoiceModal.containerDetails.splice(index, 1);
    },

    addQuotationFields() {
      let tableFields = {
        slectedStatus: "1",
        ffType: "",
        containerType: "",
        quantity: "",
        ffSellingRate: "",
        exchRate: "1",
        sellingRateFinal: "",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: "",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    getBRFData() {
     
     let payload = {
       itemCode:'getBRFData',
       allModuleId: this.$route.params.billingId,
     };

     CommonService.getAllJobList(payload)
       .then((response) => {
         const { data, status, statusText } = response;
         if (status == 200 && data.getPRBRFLAG == 1) {
           if (!isNaN(data.prbr_id) && data.prbr_id > 0) {
           this.brf_id = Number(data.prbr_id);
         }
         }
         this.isLoading = false;
       })
       .catch((error) => {
         console.log("Catch on getBRFData Error: ", error);
       });
   },
    getData(id) {
      if(this.$route.params.billingId){
        this.getBRFData();
      }
      this.ffTallyInvoiceData = [];
      this.isLoading = true;
      let type_Size = {
        itemCode: "itemCode",
        allModuleId: this.$route.params.billingId,
        InvTallyId: this.$route.query.InvTallyId,
        //allModuleId: this.$sessionsStorage.get("editSalesExId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getDataTallyBilling_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            //  console.log(data);
            // alert(data.PreviousbillingTableData.length)
            if (data.PreviousbillingTableData.length > 0) {
              this.PreviousbillingTableData = data.PreviousbillingTableData;
            }
            if (data.PreviousTallyItemTable.length > 0) {
              this.PreviousTallyItemTable = data.PreviousTallyItemTable;
              // this.getPreviousTallyItemTableData();
            }
            if (data.otherExpenseData.length > 0) {
              this.otherExpenseData = data.otherExpenseData;
            }
            if (data.otherAdditionalTask_Data.length > 0) {
              this.otherAdditionalTask_Data = data.otherAdditionalTask_Data;
            }
            //             console.log("data=>",data);
            //             console.log("data.SlinePayment_Data=>",data.SlinePayment_Data);
            // console.log("data.SlinePaymentQuery_Data=>",data.SlinePaymentQuery_Data);
            if (data.SlinePayment_Data.length > 0) {
              this.SlinePayment_Data = data.SlinePayment_Data;
            }
            // console.log("data.ExpenseDocQuery_Data=>",data.ExpenseDocQuery_Data);
            // console.log("data.ExpenseDoc_Data=>",data.ExpenseDoc_Data);
            if (data.ExpenseDoc_Data.length > 0) {
              this.ExpenseDoc_Data = data.ExpenseDoc_Data;
            }
            if (data.allContainers.length > 0) {
              this.allContainersDataArray = data.allContainers;
            }

            if (data.splitedOrMergedContainers.length > 0) {
              this.splitedOrMergedContainers = data.splitedOrMergedContainers;
            }

            if (data.billingLocationData.length > 0) {
              this.billingLocationData = data.billingLocationData;
            } else {
              this.billingLocationData = [];
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }

            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }
            if (data.allClients.length > 0) {
              this.clientData = data.allClients;
            } else {
              this.clientData = [];
            }

            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }

            if (data.mainExecutionDetails.length > 0) {
              this.mainExecutionDetails = data.mainExecutionDetails;
              this.shipmentType = data.mainExecutionDetails[0].shipmentType;
              if (this.$route.query.classId) {
                this.classId = this.$route.query.classId;
                this.ffInvoiceModal.jobNo =
                  data.mainExecutionDetails[0].mainSalesSeries + "/" + this.classId;
              } else {
                this.ffInvoiceModal.jobNo = data.mainExecutionDetails[0].mainSalesSeries;
              }

              this.ffInvoiceModal.sentForRevisedApproval =
                data.mainExecutionDetails[0].sentForRevisedApproval;
              this.ffInvoiceModal.revisedActionTakenFromMail =
                data.mainExecutionDetails[0].revisedActionTakenFromMail;

              if (this.mainExecutionDetails[0].clientType != "3") {
                this.ffInvoiceModal.clientName = data.mainExecutionDetails[0].clientName;
                this.ffInvoiceModal.clientId = data.mainExecutionDetails[0].clientId;

                this.ffInvoiceModal.acutalclientForOverSea =
                  data.mainExecutionDetails[0].exporter;
                this.ffInvoiceModal.stateName = data.mainExecutionDetails[0].stateName;
                this.ffInvoiceModal.clientgst =
                  data.mainExecutionDetails[0].gstCode +
                  data.mainExecutionDetails[0].GSTN;
                this.ffInvoiceModal.contact = data.mainExecutionDetails[0].kycContact;
                this.ffInvoiceModal.adress =
                  data.mainExecutionDetails[0].corporateAddress;
              }

              this.ffInvoiceModal.allModuleId = data.mainExecutionDetails[0].allModuleId;
              this.ffInvoiceModal.ccTypeExImp =
                data.mainExecutionDetails[0].transportType;
              this.ffInvoiceModal.shippingLine =
                data.mainExecutionDetails[0].shippingLine;
              this.ffInvoiceModal.billingLocationId =
                data.mainExecutionDetails[0].billingLocationId;

              this.ffInvoiceModal.billingLocationName =
                data.mainExecutionDetails[0].billingLocationName;

              this.getBillingBranch();

              this.getServicesData();
            }

            if (data.InvoiceData.length > 0) {
              this.ffInvoiceModal.clientName = data.InvoiceData[0].clientName;
              this.ffInvoiceModal.adress = data.InvoiceData[0].adress;
              this.ffInvoiceModal.contact = data.InvoiceData[0].contact;
              console.log("Client name => ", this.ffInvoiceModal.clientName);
            }

            if (data.InvoiceClientDetails && data.InvoiceClientDetails.length > 0) {
              this.ffInvoiceModal.clientName = data.InvoiceClientDetails[0].clientName;
              this.ffInvoiceModal.address = data.InvoiceClientDetails[0].address;
              this.ffInvoiceModal.contact = data.InvoiceClientDetails[0].contact;
              this.ffInvoiceModal.clientId = data.InvoiceClientDetails[0].clientId;

              console.log("Client name => ", this.ffInvoiceModal.clientName);
            }

            if (data.billingTableData.length > 0) {
              this.billingTableData = data.billingTableData;

              this.disableJobType = data.billingTableData[0].jobType;
            } else {
              this.billingTableData = [];
            }
            if (id == "1") {
              this.showMoreItem();
              Object.keys(this.ffInvoiceModal).map((x) => {
                this.ffInvoiceModal[x] = "";
              });
            }
            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }

            if (data.mainExecutionDetails.length > 0) {
              let arryNewBillBranch = this.billingLocationData.filter((x) => {
                if (x.branchLocation) {
                  return x.branchLocation
                    .split(",")
                    .includes(data.mainExecutionDetails[0].addedBy_user_baseLocation);
                }
                // return x.branchLocation == data.mainExecutionDetails[0].billingLocationId;
              });

              if (arryNewBillBranch.length > 0) {
                this.ffInvoiceModal.billingLocationId =
                  arryNewBillBranch[0].billingLocationId;
                this.ffInvoiceModal.billingLocationName =
                  arryNewBillBranch[0].billingLocation;
              }
            }

            this.changeOtherClient();
            this.getOceanFreight();
            this.getJobNatureOfExpenseList();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getPreviousTallyItemTableData() {
      if (this.PreviousTallyItemTable.length > 0) {
        this.ffTallyInvoiceData = [];
        let TPTParti = [];
        let TPTCon = [];
        let TPTSelO = [];
        let TPTSF = [];
        let TPTINV = [];
        //   let TCUR = [];
        let TPTRE = [];
        let TPTQUN = [];
        let INVID = [];
        let UNT = [];
        for (let p = 0; p < this.PreviousTallyItemTable.length; p++) {
          TPTParti = this.PreviousTallyItemTable[p].particulars.split(",");
          INVID = this.PreviousTallyItemTable[p].invoiceId;
          TPTCon = this.PreviousTallyItemTable[p].containerType.split(",");
          TPTQUN = this.PreviousTallyItemTable[p].quantity.split(",");
          UNT = this.PreviousTallyItemTable[p].unit.split(",");
          TPTSelO = this.PreviousTallyItemTable[p].quotationRate.split(",");
          TPTSF = this.PreviousTallyItemTable[p].sellingRateFinal.split(",");
          TPTINV = this.PreviousTallyItemTable[p].finalRateWithoutTax.split(",");
          TPTRE = this.PreviousTallyItemTable[p].remark.split(",");
          if (TPTParti.length > 0) {
            TPTParti.map((z, index) => {
              let obj2 = {
                ffType: z,
                containerType: TPTCon[index],
                quantity: TPTQUN[index],
                ffSellingRate: TPTSelO[index],
                exchRate: 1,
                sellingRateFinal: TPTSF[index],
                unit: UNT[index],
                invAmount: TPTINV[index],
                currency: "INR",

                remark:
                  TPTINV[index] == "Charges As Per Receipt"
                    ? "Charges As Per Receipt " + " && " + TPTRE[index]
                    : TPTRE[index],
                mainffId: INVID,
                slectedStatus: "0",
                color: "",
              };
              this.ffTallyInvoiceData.push(obj2);
              //  this.tptCheckDone = 1;
            });
          }
        }
      }
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// newTallyConBillingMerge.vue?19a8ca2c